export default "__VITE_ASSET__BCgiQWWG__"